(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('CategoryFranchiserFormController', CategoryFranchiserFormController)

    /** @ngInject */
    function CategoryFranchiserFormController($state, $stateParams, LoadingHelper, sweetAlert, UtilHelper, CategoryService) {
        const vm = this;
        const categoryId = $stateParams.categoryId;

        vm.saveCategory = () => {
            LoadingHelper.startLoading('.loading-holder');

            vm.categoryData.Image = '';

            if (!vm.categoryData.Id) {
                CategoryService
                    .post(vm.categoryData)
                    .then(success => successCallback(success, true), errorCallback);
            } else {
                CategoryService
                    .put(vm.categoryData)
                    .then(success => successCallback(success, false), errorCallback);
            }
        }

        vm.deleteCategory = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    LoadingHelper.startLoading('.loading-holder');

                    CategoryService
                        .deleteData(categoryId)
                        .then(() => {
                            $state.go('app.franchiser-categories-list')
                            LoadingHelper.stopLoading('.loading-holder');
                            UtilHelper.successCallback('delete');
                        }, error => {
                            UtilHelper.errorCallback(error);
                            LoadingHelper.stopLoading('.loading-holder');
                        })
                }
            })
        }

        init();

        function getCategory() {
            if (!categoryId)
                return;

            LoadingHelper.startLoading('.loading-holder');

            CategoryService
                .get(categoryId)
                .then(success => {
                    vm.categoryData = success;
                    LoadingHelper.stopLoading('.loading-holder');
                }, error => {
                    LoadingHelper.stopLoading('.loading-holder');
                    UtilHelper.errorCallback(error);
                })
        }

        function successCallback(success, isPost) {
            if (isPost) {
                vm.categoryData = success;

                $state.go('app.franchiser-categories-edit', {
                    categoryId: vm.categoryData.Id
                }, {
                    notify: false
                });

                UtilHelper.successCallback('create');
            } else {
                UtilHelper.successCallback('update');
            }

            LoadingHelper.stopLoading('.loading-holder');
        }

        function errorCallback(error) {
            LoadingHelper.stopLoading('.loading-holder');
            UtilHelper.errorCallback(error);
        }

        function init() {
            getCategory();
        }
    }
}());